import {z} from "zod";

const schema = z.object({
	fileId: z.string()
});

const model = schema.transform((values) => ({
	...values
}));

export const FilePersistModel = {schema, model};
export type IFilePersistModel = z.infer<typeof FilePersistModel.model>;
export const DEFAULT_FILE_PERSIST: IFilePersistModel = {
	fileId: ""
};
